// AUTO-GENERATED by scripts/optimize-images.js — do not edit by hand
import bloomAssistantWebp from './bloom-assistant-640.webp';
import bloomAssistantWebp2x from './bloom-assistant-1280.webp';
import bloomAssistantFallback from './bloom-assistant-1280.jpeg';
import devflowWebp from './devflow-640.webp';
import devflowWebp2x from './devflow-1280.webp';
import devflowFallback from './devflow-1280.jpeg';
import tollerWebp from './toller-640.webp';
import tollerWebp2x from './toller-1280.webp';
import tollerFallback from './toller-1280.jpeg';
import spectraWebp from './spectra-640.webp';
import spectraWebp2x from './spectra-1280.webp';
import spectraFallback from './spectra-1280.jpeg';
import expenseTrackerWebp from './expense-tracker-640.webp';
import expenseTrackerWebp2x from './expense-tracker-1280.webp';
import expenseTrackerFallback from './expense-tracker-1280.jpeg';
import patitasWebp from './patitas-640.webp';
import patitasWebp2x from './patitas-1280.webp';
import patitasFallback from './patitas-1280.jpeg';
import stagedWebp from './staged-640.webp';
import stagedWebp2x from './staged-1280.webp';
import stagedFallback from './staged-1280.jpeg';
import atriumWebp from './atrium-640.webp';
import atriumWebp2x from './atrium-1280.webp';
import atriumFallback from './atrium-1280.jpeg';

export interface ImageSources {
  webp: string;
  webp2x: string;
  fallback: string;
  width: number;
  height: number;
}

export const IMAGE_MANIFEST = {
  bloomAssistant: { webp: bloomAssistantWebp, webp2x: bloomAssistantWebp2x, fallback: bloomAssistantFallback, width: 1280, height: 714 },
  devflow: { webp: devflowWebp, webp2x: devflowWebp2x, fallback: devflowFallback, width: 1280, height: 714 },
  toller: { webp: tollerWebp, webp2x: tollerWebp2x, fallback: tollerFallback, width: 1280, height: 714 },
  spectra: { webp: spectraWebp, webp2x: spectraWebp2x, fallback: spectraFallback, width: 1280, height: 714 },
  expenseTracker: { webp: expenseTrackerWebp, webp2x: expenseTrackerWebp2x, fallback: expenseTrackerFallback, width: 1280, height: 714 },
  patitas: { webp: patitasWebp, webp2x: patitasWebp2x, fallback: patitasFallback, width: 1280, height: 714 },
  staged: { webp: stagedWebp, webp2x: stagedWebp2x, fallback: stagedFallback, width: 1280, height: 714 },
  atrium: { webp: atriumWebp, webp2x: atriumWebp2x, fallback: atriumFallback, width: 1280, height: 714 },
} as const satisfies Record<string, ImageSources>;

// Precise union of the manifest keys, e.g. 'patitas' | 'staged' | ...
// Use this to type lookups so a renamed/missing image is a compile error.
export type ImageKey = keyof typeof IMAGE_MANIFEST;
